const ableToModifyPurchaseRate = (userId) => {
  let users = [
    "6655d9b40777525410c88982", // Aksha Ma'am
    "651bd4c8ad7773279c5ae380", // Vanshita
    "6746d54f4d93e350eadae03f", // Darshan Bhai
  ];
  return users.includes(userId);
};

export default ableToModifyPurchaseRate;
